<div class="modal-header">
  <h4 class="modal-title">{{'manageAccessories.title.add'| translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner d-flex align-content-center">
    <form class="m-1 w-100" novalidate [formGroup]="form">
      <div class="col-12 mb-3 row align-content-center">
        <label class="col-md-4 col-form-label">{{'manageAccessories.source_article' | translate}}</label>
        <div class="col-md-8">
          <input type="text"
                 class="form-control"
                 [class.is-invalid]="form.controls?.source?.touched && form.controls?.source?.invalid"
                 formControlName="source"
                 name="source">
        </div>
        <div *ngIf="form.controls?.source?.touched && form.controls?.source?.invalid" class="ps-3 invalid-feedback d-flex">{{getInputError(form.get('source'))}}</div>
      </div>
      <div class="col-12 mb-3 row align-content-center">
        <label class="col-md-4 col-form-label">{{'manageAccessories.rotationDelta' | translate}}</label>
        <div class="col-md-8">
          <input type="text"
                 class="form-control"
                 inputRestricter="{{inputValueRestricter}}"
                 [class.is-invalid]="form.controls?.rotationDelta?.touched && form.controls?.rotationDelta?.invalid"
                 formControlName="rotationDelta"
                 name="rotationDelta">
        </div>
        <div *ngIf="form.controls?.rotationDelta?.touched && form.controls?.rotationDelta?.invalid" class="ps-3 invalid-feedback d-flex">{{getInputError(form.get('rotationDelta'))}}</div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button [disabled]="form.invalid || !form.dirty" class="btn btn-primary btn-forward" (click)="save()">
    {{'global.label.add' | translate}}
  </button>
</div>
